<template>
	<div class="dashboard-temp-worker-mission">
		<shared-google-map
			v-if="mission?.latitude && mission?.longitude"
			:latitude="mission.latitude"
			:longitude="mission.longitude"
			is-cover
			class="dashboard-temp-worker-mission__map"/>

		<shared-app-aside-item title="Lieu de mission">
			<span v-html="setup.missionPlace"/>
		</shared-app-aside-item>

		<shared-app-aside-item title="Dates">
			Du {{ mission?.startDate.toReadableDate() }} au {{ mission?.endDate.toReadableDate() }}
		</shared-app-aside-item>

		<shared-app-aside-item title="Horaires">
			<span
				v-if="mission?.contractHour"
				v-html="setup.contractHoursToReadable(mission.contractHour)"/>
			<span v-else>
				De {{ mission?.startDate.toReadableDate('$hhh$mm') }}
				à {{ mission?.endDate.toReadableDate('$hhH$mm') }}
			</span>
		</shared-app-aside-item>

		<shared-app-aside-item title="Interlocuteur">
			{{ mission?.interlocutor }}
		</shared-app-aside-item>

		<o-button
			class="dashboard-temp-worker-mission__contract-button"
			color="info"
			outline
			block
			@click="setup.goToContract()">
			Voir le contrat
		</o-button>
	</div>
</template>

<script setup lang="ts">
import SharedGoogleMap from '@/components/shared/SharedGoogleMap.vue';
import DashboardTempWorkerMissionSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerMissionSetupService';
const props = defineProps(DashboardTempWorkerMissionSetupService.props);
const setup = new DashboardTempWorkerMissionSetupService(props);
</script>

<style scoped lang="less">

.dashboard-temp-worker-mission {

	margin-top: 1rem;

	&__map {
		height: 10rem;
		margin-bottom: 1rem;
	}

	&__contract-button {
		margin-top: 1rem;
	}
}

</style>
